import React from 'react';
import PropTypes from 'prop-types';

import Message from 'react/components/Chat/Message';
import SupportRequest from 'react/components/Chat/SupportRequest';

function ChatWindowBody({
  ticketActionsIsOpen,
  chatHistory,
  chatHistoryBottomScrollRef,
  messages,
  chat,
  loggedUserId
}) {
  return (
    <div
      className={`chatHistoryLog ${ticketActionsIsOpen && 'ticketActionsIsOpen'}`}
      ref={chatHistory}
    >
      {messages.map((message, i) => (
        <Message
          key={message.get('id')}
          message={message}
          nextMessage={messages.toJS()[i + 1]}
          previousMessage={messages.toJS()[i - 1]}
          loggedUserId={loggedUserId}
        />
      ))}
      {chat.get('activeCall') && (
      <SupportRequest
        chatId={chat.get('id')}
        userId={chat.getIn(['activeCall', 'userId'])}
      />
      )}
      <div ref={chatHistoryBottomScrollRef} style={{ clear: 'both' }} />
    </div>
  );
}

ChatWindowBody.propTypes = {
  ticketActionsIsOpen: PropTypes.bool.isRequired,
  chat: PropTypes.object.isRequired,
  messages: PropTypes.object.isRequired,
  chatHistory: PropTypes.object.isRequired,
  chatHistoryBottomScrollRef: PropTypes.object.isRequired,
  loggedUserId: PropTypes.number.isRequired
};

export default ChatWindowBody;
